export enum IncidentAction {
  SENT = "SENT",
  BLOCKED = "BLOCKED",
}
